import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RequireCompanyAdmin = ({ children }) => {
  const { isAuthenticated, isCompanyAdmin, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/auth" replace />;
  if (!isCompanyAdmin) return <Navigate to="/" replace />;
  return children;
};

export default RequireCompanyAdmin;
